export default __webpack_public_path__ + "static/media/PC.3109b6e7.jpg";